import React, { useMemo } from "react";
import { ConnectionProvider, WalletProvider } from "@solana/wallet-adapter-react";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-phantom";
import { SolflareWalletAdapter } from "@solana/wallet-adapter-solflare";

// Default RPC endpoint. The canonical api.mainnet-beta.solana.com endpoint
// blocks browser traffic (403 on requests carrying an Origin header), so we
// default to a browser-friendly public RPC. Set REACT_APP_SOLANA_RPC to a paid
// RPC in production (public endpoints rate-limit heavily).
const endpoint =
  process.env.REACT_APP_SOLANA_RPC || "https://solana-rpc.publicnode.com";

// Wraps the app with the Solana wallet context so any component can call
// useWallet()/useWalletModal(). Phantom is the primary wallet; Solflare is
// included as a common second option. Modern wallets that implement the
// Wallet Standard are auto-detected even without an explicit adapter here.
export default function SolanaProvider({ children }) {
  const wallets = useMemo(
    () => [new PhantomWalletAdapter(), new SolflareWalletAdapter()],
    []
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>{children}</WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}
